// @ts-nocheck
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import icons from '../../../../constants/icons';

function Company({ option }) {
  return (
    <>
      <div className="icon-wrapper companny">
        <FontAwesomeIcon icon={icons.COMPANY} />
      </div>
      <div className="item-content">
        <span>{option.title}</span>
      </div>
    </>
  );
}



export default Company;
